<!--修改学期-->
<template>
    <div>
        <vue-scroll :ops="$ops">
            <div v-loading="$parentInfo.dialog_GetSemesterDetail.loading">
                <el-form ref="$parentInfo.dialog_GetSemesterDetail.semester"
                         :model="$parentInfo.dialog_GetSemesterDetail.semester" label-width="85px">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="学期名">
                                <el-input v-model="$parentInfo.dialog_GetSemesterDetail.semester.name"
                                          placeholder="请输入学期名">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item>
                                <el-radio-group v-model="$parentInfo.dialog_GetSemesterDetail.semester.type">
                                    <el-radio :label="1">春季班</el-radio>
                                    <el-radio :label="2">暑期班</el-radio>
                                    <el-radio :label="3">秋季班</el-radio>
                                    <el-radio :label="4">寒假班</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="开始时间">
                                <el-date-picker
                                        v-model="$parentInfo.dialog_GetSemesterDetail.semester.start_date"
                                        type="date"
                                        placeholder="请选择开始时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="结束时间">
                                <el-date-picker
                                        v-model="$parentInfo.dialog_GetSemesterDetail.semester.end_date"
                                        type="date"
                                        placeholder="请选择结束时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="年级">
                                <el-select v-model="grade_id" placeholder="选择年级" style="width: 120px">
                                    <el-option
                                            v-for="item in $parentInfo.filter.grades"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="课时">
                                <el-input-number v-model="period" size="medium" :min="0" :max="50"
                                                 placeholder="请输入课时"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="一对一价格">
                                <el-input-number size="medium" :controls=false
                                                 v-model="oneToOnePrice"
                                                 placeholder="请输入一对一价格"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="一对三价格">
                                <el-input-number size="medium" :controls=false
                                                 v-model="oneToThreePrice"
                                                 placeholder="请输入一对三价格"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="一对多价格">
                                <el-input-number size="medium" :controls=false
                                                 v-model="oneToMorePrice"
                                                 placeholder="请输入一对多价格"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item>
                                <el-button @click="handleAddCourseMsg()">适用全部</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-form>
                    <el-form-item>
                        <el-tabs v-model="activeName">
                            <el-tab-pane v-for="(course,index) in $parentInfo.dialog_GetSemesterDetail.courses"
                                         :name="index.toString()"
                                         :label=course.title
                                         :key=index>
                                <table class="table table-striped">
                                    <thead>
                                    <tr>
                                        <th>科目</th>
                                        <th>课时</th>
                                        <th>一对一</th>
                                        <th>一对三</th>
                                        <th>一对多</th>
                                        <th>衔接</th>
                                        <th>课时</th>
                                        <th>Ti</th>
                                        <th>课时</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(subject,index) in course.subjects" :key="index">
                                        <td>
                                            <el-input v-model="subject.name[0]" style="width: 100px"></el-input>
                                        </td>
                                        <td>
                                            <el-input v-model="subject.period[0]"></el-input>
                                        </td>
                                        <td>
                                            <el-input v-model="subject.onePrice[0]"></el-input>
                                        </td>
                                        <td>
                                            <el-input v-model="subject.threePrice[0]"></el-input>
                                        </td>
                                        <td>
                                            <el-input v-model="subject.manyPrice[0]"></el-input>
                                        </td>
                                        <td>
                                            <el-input v-model="subject.cohesionPrice[0]"></el-input>
                                        </td>
                                        <td>
                                            <el-input v-model="subject.cohesionPeriod[0]"></el-input>
                                        </td>
                                        <td>
                                            <el-input v-model="subject.tiPrice[0]"></el-input>
                                        </td>
                                        <td>
                                            <el-input v-model="subject.tiPeriod[0]"></el-input>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </el-tab-pane>
                        </el-tabs>
                    </el-form-item>
                </el-form>
            </div>
        </vue-scroll>
        <div class="text-right">
            <el-button type="primary" @click="handleUpdateSemester()"
                       :loading="$parentInfo.dialog_GetSemesterDetail.button_loading">修改
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_GetSemesterDetail",
        data() {
            return {
                grade_id: '',
                period: '',
                oneToOnePrice: 0,
                oneToTwoPrice: 0,
                oneToThreePrice: 0,
                oneToSixPrice: 0,
                oneToMorePrice: 0,
                activeName: '1'
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.dialog_GetSemesterDetail.loading = true;
            this.handleIndexSemester();
        },
        methods: {
            //获取学期
            handleIndexSemester() {
                this.$wApi.send(this.$parentInfo.path, 'get_semesterDetail', {
                    'id': this.$store.state.modal.data.semester_id,
                });
            },
            //修改学期
            handleUpdateSemester() {
                if (this.$parentInfo.dialog_GetSemesterDetail.semester.start_date.length !== 0) {
                    this.$parentInfo.dialog_GetSemesterDetail.semester.start_date = this.$moment(this.$parentInfo.dialog_GetSemesterDetail.semester.start_date).format('YYYY-MM-DD');
                }
                if (this.$parentInfo.dialog_GetSemesterDetail.semester.end_date.length !== 0) {
                    this.$parentInfo.dialog_GetSemesterDetail.semester.end_date = this.$moment(this.$parentInfo.dialog_GetSemesterDetail.semester.end_date).format('YYYY-MM-DD');
                }
                this.$parentInfo.dialog_GetSemesterDetail.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'update_semesterDetail', {
                    'id': this.$store.state.modal.data.semester_id,
                    'name': this.$parentInfo.dialog_GetSemesterDetail.semester.name,
                    'start_date': this.$parentInfo.dialog_GetSemesterDetail.semester.start_date,
                    'end_date': this.$parentInfo.dialog_GetSemesterDetail.semester.end_date,
                    'courses': this.$parentInfo.dialog_GetSemesterDetail.courses,
                    'type': this.$parentInfo.dialog_GetSemesterDetail.semester.type,
                    'section_id': this.$parentInfo.dialog_GetSemesterDetail.section_id
                });
            },
            //为每门课课时，价格定基础值
            handleAddCourseMsg() {
                if (this.grade_id === '') {
                    this.$message({
                        message: '请选择年级',
                        type: 'warning'
                    });
                } else {
                    for (const key in this.$parentInfo.dialog_GetSemesterDetail.courses) {
                        if (this.$parentInfo.dialog_GetSemesterDetail.courses[key].id === this.grade_id) {
                            for (const item of this.$parentInfo.dialog_GetSemesterDetail.courses[key].subjects) {
                                this.$set(item.period, 0, this.period);
                                this.$set(item.onePrice, 0, this.oneToOnePrice);
                                this.$set(item.twoPrice, 0, this.oneToTwoPrice);
                                this.$set(item.threePrice, 0, this.oneToThreePrice);
                                this.$set(item.sixPrice, 0, this.oneToSixPrice);
                                this.$set(item.manyPrice, 0, this.oneToMorePrice);
                            }
                        }
                    }
                }
            },
            //移除学科
            handleRemoveSubject(index1, item) {
                let index2 = this.$parentInfo.dialog_GetSemesterDetail.courses[index1].subjects.indexOf(item);
                if (index2 !== -1) {
                    this.$parentInfo.dialog_GetSemesterDetail.courses[index1].subjects.splice(index2, 1)
                }
            },
            //添加学科
            handleAddSubject(index1) {
                this.$parentInfo.dialog_GetSemesterDetail.courses[index1].subjects.push({
                    id: '',
                    name: '',
                    period: '',
                    onePrice: '',
                    threePrice: '',
                    sixPrice: '',
                    manyPrice: '',
                    cohesionPrice:'',
                    cohesionPeriod:'',
                    tiPrice:'',
                    tiPeriod:'',
                });
            },
        }
    }
</script>

<style scoped>
    .text {
        position: absolute;
        left: 25px;
        top: 25px;
    }

    .box_relative {
        position: relative;
    }

    .card-body {
        height: calc(100vh - 125px);
    }

    .card-footer {
        position: fixed;
        width: calc(100% - 20px);
        padding: 5px 10px;
        bottom: 0;
    }
</style>
